export default __webpack_public_path__ + "static/media/Dial_Black_Orange.88d99974.png";